import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=a41f952e&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=ts"
export * from "./orderList.vue?vue&type=script&lang=ts"
import style0 from "./orderList.vue?vue&type=style&index=0&id=a41f952e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41f952e",
  null
  
)

export default component.exports